import TestimonialCard from "./TestimonialCard";
import TestimonialMarquee from "./TestimonialMarquee";

export default function Testimonials({ colors }) {
  const creators = [
    {
      name: "Vinay Rathore",
      type: "Music Teacher",
      avatar_url: "/assets/images/testimonial-vinay.webp",
      testimonial:
        "qoohoo is simply a one-stop solution to many of my problems. Organising and maintaining online courses at Musicwale was a mess until qoohoo came. As a creator I think the most powerful thing is knowing that it's “you” who has the power.",
    },
    {
      name: "Raghavendra",
      type: "Finance Expert",
      avatar_url: "/assets/images/testimonial-ragh.webp",
      testimonial:
        "qoohoo enabled us to monetize our existing community by removing all major roadblocks like payment gateway, course & community offerings. We were able to build our first 300 paid subscriptions on qoohoo in a span of just 2 months.",
    },
    {
      name: "Rachit",
      type: "Music and Literature Enthusiast",
      avatar_url: "/assets/images/testimonial-rachit.webp",
      testimonial:
        "Bookclub won't even exist if it weren't for qoohoo. It is so easy to create, maintain and monetise a community on qoohoo that I don't think twice before investing my time there. And now I am building a side venture apart from my music.",
    },
    {
      name: "Muskan Bamne",
      type: "TV Actress",
      avatar_url: "/assets/images/testimonial-muskan.webp",
      testimonial:
        "qoohoo filled the communication gap that I always felt with my audience on social media. It's smooth and fun app to connect with people directly and share things without privacy issues.",
    },
    {
      name: "SMT Sebi Registered",
      avatar_url: "/assets/images/testimonial-smt.png",
      type: "SEBI registered creator",
      testimonial:
        "“When it comes to scaling up your business, operations automation is the foremost requirement, and this won't be possible without a dedicated, supportive, and responsive team. And the qoohoo team is doing a really fantastic remarkable job. Thanks qoohoo for your support.”",
      image: "/assets/images/telegram-payments-automation.png",
    },
    {
      name: "Exam Tak Hindi",
      avatar_url: "/assets/images/testimonial-examtak.png",
      type: "GK & Current affairs teacher",
      testimonial:
        "Hi, I'm using qoohoo since last 4 months & my experience is amazing with it. I save a lot of time because qoohoo's automation works smoothly, and the support team is also very helpful. Overall, after I started using qoohoo, my revenue increased drastically. Thanks again.",
      image: "/assets/images/telegram-payments-growth.png",
    },
    {
      name: "Nipun - Your Competitive Mentor",
      avatar_url: "/assets/images/testimonial-nipun.png",
      type: "Assistant Commissioner Of State Tax, MPSC Educator",
      testimonial:
        "We have been using qoohoo service since 1 year.. it has been an amazing and seamless experience with service. Customer support is very quick to respond. That helps us to solve any problems that we face in no time. Thank you, qoohoo! 🤝 🤝",
      image: "/assets/images/telegram-payments-support.png",
    },
    {
      name: "Mahesh - Exam Oriented Academy",
      avatar_url: "/assets/images/testimonial-mahesh.png",
      type: "Education creator",
      testimonial:
        "Nice app. One stop solution to my needs. Now students can easily join my telegram group without any involvement from my side. Thank you qoohoo",
      image: "/assets/images/telegram-payments-share-card.png",
    },
  ];

  return (
    <>
      <div className="hidden md:block">
        <TestimonialMarquee colors={colors} creators={creators} />
      </div>
      <div className="md:hidden flex flex-col items-center gap-3">
        {creators.map((creator, idx) => {
          return (
            <TestimonialCard key={idx} creator={creator} colors={colors} />
          )
        })}
      </div>
    </>
  );
}
